import { render, staticRenderFns } from "./ObjectNumberCell.vue?vue&type=template&id=164cacba&"
import script from "./ObjectNumberCell.vue?vue&type=script&lang=js&"
export * from "./ObjectNumberCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports